// dome

export default [
  // dome
  {
    path: '/article',
    name: 'Article',
    component: () =>
    import(/* webpackChunkName: "Dome" */ '@/components/operating-system/article/scan')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/article.js